import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { MutationKeyConfig } from "../../../../../api/api-helper";
import { InvalidateRoute } from "../../../../../hooks/useDeleteData";
import { useReactHookForm } from "../../../../../hooks/useReactHookForm";
import { useState } from "react";
import { useSaveData } from "../../../../../hooks/useSaveData";
import { ReactHookForm } from "../../../../../components/hook-form/react-hook-form.component";
import { CreatePlanForm } from "./create-plan.from";
import { useLoadData } from "../../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../../models/api-response";
import { planApiKeyStore } from "../../../../../api/plan-api-key-store";
import { useSnackbar } from "../../../../../hooks/use-snackbar.hook";
import { useAuthorize } from "../../../../../hooks/use-authorize";
import { UserPermissionName } from "../../../../../models/user-permission-name";

interface PlanRequestArgs {
    customerID?: number;
    projectID?: number;
    officeID?: number;
    unitID?: number;
}

interface CreatePlanDialog {
    data: any;
    planListData: any;
    yupSchema?: any;
    planRequestArgs: PlanRequestArgs;
    onClosed: () => void
    config: { saveConfig: MutationKeyConfig; invalidateRoute?: InvalidateRoute };
}
export const CreatePlanComponent = ({
    data,
    planListData,
    yupSchema,
    planRequestArgs,
    onClosed,
    config: { saveConfig, invalidateRoute },
}: CreatePlanDialog) => {


    const { showSnackbar } = useSnackbar();
    const form = useReactHookForm({
        defaultValues: {
            ...data,
            customer: { customerID: planRequestArgs?.customerID, customerName: '' },
            office: { officeID: planRequestArgs?.officeID, officeName: '' },
            project: { projectID: planRequestArgs?.projectID, projectName: '' },
            unit: { unitID: planRequestArgs?.unitID, unitName: '' },
            sqFootage: data?.area ?? '',
            volume: data?.volume ?? '',
            worstcaseScore: data?.worstcaseScore ?? '',
            windowArea: data?.windowArea ?? '',
            associatedPlan: { planID: data?.planAssociatedWithPlanID ?? '', planName: '' },
            wallHeight: data?.wallHeight ?? '',
            uploadedFile: data?.fileName ?? '',
            uploadedFileType: data?.fileType ?? '',
            planReviewTypeID: data?.planReviewTypeID ?? ''
        },
        yupSchema,
    });
    const [planReqArgs, setPlanReqArgs] = useState(planRequestArgs);
    const [fileData, setFileData] = useState<File>();
    const [isFileDeleted, setFileDeleted] = useState<boolean>(false);

    const { isLoading, isError, error, mutateAsync } = useSaveData(saveConfig, invalidateRoute);

    const getExtension = (fileName: string) => {
        const extension = "." + fileName?.split('.').pop();
        return extension;
    }

    const validatePlanType = (planFileType: number) => {
        if (planFileType == 1) {
            const checkPlanType = planListData?.some((plan: any) => plan.planFileTypeID === Number(planFileType));
            if (checkPlanType) {
                showSnackbar('Plan already created for master plan', 'error');
                return true
            }
        }
        return false;
    }

    const handleSubmit = async (value: any) => {

        if (value?.planID) {
            if (data?.planFileTypeID !== 1) {
                if (validatePlanType(value?.planFileTypeID)) return
            }
        }
        else {
            if (validatePlanType(value?.planFileTypeID)) return;
        }
        const formData = new FormData();
        formData.append('PlanID', value?.planID ?? '');
        formData.append('PlanName', value?.planName ?? '');
        formData.append('customerID', value?.customer?.customerID ?? '');
        // formData.append('officeID', value?.office?.officeID ?? '');
        // formData.append('projectID', value?.project?.projectID ?? '');
        formData.append('unitID', value?.unit?.unitID ?? '');
        formData.append('UploadedFile', fileData ?? '');
        formData.append('PlanFileName', fileData ? fileData?.name : value?.uploadedFile ?? '');
        formData.append('PlanFileType', fileData ? getExtension(fileData?.name) : value?.uploadedFile ? getExtension(value?.uploadedFile) : "");
        formData.append('PlanFileTypeID', value?.planFileTypeID ?? '');
        formData.append('Area', value?.sqFootage ?? '');
        formData.append('Volume', value?.volume ?? '');
        formData.append('WorstcaseScore', value?.worstcaseScore ?? '');
        formData.append('WindowArea', value?.windowArea ?? '');
        formData.append('WallHeight', value?.wallHeight ?? '');
        formData.append('AssociatedPlanID', value?.associatedPlan?.planID);
        formData.append('PlanReviewTypeID', value?.planReviewTypeID);
        if (isFileDeleted) formData.append('IsFileDeleted', isFileDeleted.toString());

        await mutateAsync({ data: formData });
        onClosed();
    }

    const handleUploadFile = (file: File) => {
        setFileData(file);
        setFileDeleted(false);
        if (data?.fileName && !file) setFileDeleted(true)
    }

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <ReactHookForm formName="SAVE_UNIT_PLAN_LIBRARY_FORM" onSubmit={handleSubmit} formContextProps={form} isBusy={isLoading}>
            <Grid container spacing={2}>
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                    <CreatePlanForm uploadFile={handleUploadFile} planRequestArgs={planReqArgs} />
                </Grid>
                <Grid item lg={12} sm={12} xl={12} xs={12} className="spaceBetween">
                    <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        disabled={isReadOnlyPermission}
                        variant="contained"
                        style={{ width: '130px' }}
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
        </ReactHookForm>
    );
}